import { useMemo } from 'react';
import { EventType, Status } from '../graphql/graphql';
import { useEventStore } from '../stores/eventStore';
import { useChatBoxStateStore } from '../stores/chatBoxStateStore';
import { useLineOfBusiness } from './useLineOfBusiness';
export const useIsWaitingWelcome = () => {
    const { events } = useEventStore();
    const { lineOfBusiness } = useLineOfBusiness();
    const { allowFirstMessage } = useChatBoxStateStore(lineOfBusiness);
    return useMemo(() => {
        var _a;
        return (events.length === 0 ||
            (events.length === 1 &&
                events[0].type === EventType.SupportCaseStatus &&
                ((_a = events[0].supportCaseStatusEvent) === null || _a === void 0 ? void 0 : _a.status) === Status.Open &&
                !allowFirstMessage));
    }, [allowFirstMessage, events]);
};
